// Analytics helper functions
const SUBSCRIPTION_TYPES = {
  D_ETC: 'D-ETC',
  H_ETC: 'H-ETC',
  KLOKA_H: 'KLOKA H',
  PLAY: 'PLAY'
};

export function getAnalyticsProps() {
  const loggedInInfo = document.getElementById('logged-in-info');
  const loggedIn = loggedInInfo?.dataset.loggedIn ?? false;
  const device = loggedInInfo?.dataset.device ?? "web";
  const subscriptions = loggedInInfo?.dataset.subscriptions ?? "";
  const subscriptionsArray = subscriptions.split(',');

  return {
    logged_in: loggedIn,
    device: device,
    [SUBSCRIPTION_TYPES.D_ETC]: subscriptionsArray.includes(SUBSCRIPTION_TYPES.D_ETC),
    [SUBSCRIPTION_TYPES.H_ETC]: subscriptionsArray.includes(SUBSCRIPTION_TYPES.H_ETC),
    [SUBSCRIPTION_TYPES.KLOKA_H]: subscriptionsArray.includes(SUBSCRIPTION_TYPES.KLOKA_H),
    [SUBSCRIPTION_TYPES.PLAY]: subscriptionsArray.includes(SUBSCRIPTION_TYPES.PLAY),
  };
}

// Debounce function to prevent too many rapid analytics calls
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
